import { REVIEW_DETAILS } from './constants';

export const getEditActionName = (fieldName: string) => {
    switch (fieldName) {
        case REVIEW_DETAILS.CUSTOMER_DETAILS:
            return 'edit_customer_details';
        case REVIEW_DETAILS.VEHICLE_DETAILS:
            return 'edit_vehicle_details';
        case REVIEW_DETAILS.PLAN_DETAILS:
            return 'edit_plan_details';
        default:
            return '';
    }
};
